var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import { useSelector } from "react-redux";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
import actions from "@mainDi/features/AIF-PMS/actions";
var SidebarFooter = function (_a) {
    var addBrokerVisible = _a.addBrokerVisible, setAddBrokerVisible = _a.setAddBrokerVisible, form = _a.form, setVisible = _a.setVisible, subCategoryId = _a.subCategoryId, setIsToastModal = _a.setIsToastModal, setMessage = _a.setMessage, onSuccessPassoutAndEmpDetails = _a.onSuccessPassoutAndEmpDetails;
    var cActions = actions();
    var orderBook = useSelector(function (state) { return state.markets.orderBook; }).orderBookDetails;
    var isDisabled = !form.passout_percent || !form.passout_user_code;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "footer-container" },
            React.createElement(EdButton, { onClick: function () {
                    setVisible(false);
                    setAddBrokerVisible(false);
                }, btnTyp: "link", value: "Cancel", className: "DMSans_16_500" }),
            React.createElement(EdButton, { onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                    var _a, _b, _c, _d;
                    return __generator(this, function (_e) {
                        aifPmsDi.orderBook
                            .updateleadorderbook(__assign(__assign({}, form), { order_type: (_a = orderBook === null || orderBook === void 0 ? void 0 : orderBook.data) === null || _a === void 0 ? void 0 : _a.order_type, order_id: ((_b = orderBook === null || orderBook === void 0 ? void 0 : orderBook.data) === null || _b === void 0 ? void 0 : _b.order_type) == "T"
                                ? (_c = orderBook === null || orderBook === void 0 ? void 0 : orderBook.data) === null || _c === void 0 ? void 0 : _c.transactionId
                                : (_d = orderBook === null || orderBook === void 0 ? void 0 : orderBook.data) === null || _d === void 0 ? void 0 : _d.order_id, passout_user_type: "P" }))
                            .then(function (res) {
                            var _a, _b, _c, _d, _e, _f, _g;
                            if (res &&
                                (res === null || res === void 0 ? void 0 : res.data) &&
                                ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.status) &&
                                ((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.status) === "SUCCESS") {
                                onSuccessPassoutAndEmpDetails();
                                aifPmsDi.orderBook.orderbookdetails({
                                    CategoryCode: subCategoryId,
                                    TransactionId: ((_c = orderBook === null || orderBook === void 0 ? void 0 : orderBook.data) === null || _c === void 0 ? void 0 : _c.order_type) == "T"
                                        ? (_d = orderBook === null || orderBook === void 0 ? void 0 : orderBook.data) === null || _d === void 0 ? void 0 : _d.transactionId
                                        : (_e = orderBook === null || orderBook === void 0 ? void 0 : orderBook.data) === null || _e === void 0 ? void 0 : _e.order_id,
                                    ordertype: (_f = orderBook === null || orderBook === void 0 ? void 0 : orderBook.data) === null || _f === void 0 ? void 0 : _f.order_type,
                                });
                                setIsToastModal(true);
                                setMessage(((_g = orderBook === null || orderBook === void 0 ? void 0 : orderBook.data) === null || _g === void 0 ? void 0 : _g.sbCode)
                                    ? "SB passout% updated successfully."
                                    : "SB details added successfully.");
                                setAddBrokerVisible(false);
                            }
                            else {
                                setIsToastModal(true);
                                setMessage(res === null || res === void 0 ? void 0 : res.message);
                            }
                        });
                        return [2 /*return*/];
                    });
                }); }, btnTyp: isDisabled ? "midnight-blue" : "tomato-red", value: "Save", className: "save-button rounded-pill DMSans_16_500", disabled: isDisabled }))));
};
export default SidebarFooter;
